import type { Meta } from '../../../generated/frontend'
import { getUpdatedAtDate } from '../../../shared/utils/get-updated-at-date'
import { removeUrlQueryStringAndFragment } from '../../../shared/utils/remove-url-query-string-and-fragment'
import { getPageComponentsText } from './get-components-text'

type BaseDataLayerInput =
  | Record<string, any>
  | {
      articleBodyTemplate: Record<string, any>
      extraPageComponents?: string[]
    }

export const baseDataLayer = (
  meta: Meta,
  urls: { currentUrl: string; previousUrl?: string },
  input: BaseDataLayerInput
) => {
  const articleBodyTemplate = 'articleBodyTemplate' in input ? input.articleBodyTemplate : input
  const extraPageComponents = 'articleBodyTemplate' in input ? input.extraPageComponents || [] : []

  return {
    // Keep existing detected components and allow page-specific suffixes.
    pageComponents: [getPageComponentsText(articleBodyTemplate), ...extraPageComponents]
      .filter(Boolean)
      .join('|'),
    wcdPageUrl: removeUrlQueryStringAndFragment(urls.currentUrl),
    previousWcdPageUrl: urls.previousUrl || '',
    contentPublishedDate: getUpdatedAtDate(meta.publishedDate),
    contentUpdatedDate: getUpdatedAtDate(meta.updatedDateTime),
    systemContentPublishedDate: getUpdatedAtDate(meta.systemContentPublishedDate),
    systemContentUpdatedDate: getUpdatedAtDate(meta.systemContentUpdatedDate),
    glideCurationDate: meta.glideCurationDate,
    frequencyOfUpdate: meta.frequencyOfUpdate,
    significantUpdate: meta.significantUpdate,
  }
}
